import React from "react";
import { FaWallet, FaCreditCard, FaExchangeAlt } from "react-icons/fa";

/**
 * Top-of-right-column tabs: Wallet | Direct | Card.
 *
 * P3.2 v2 — tab visibility is DRIVEN by the backend. `/info`
 * returns `paymentMethods: ['x402'|'direct', ...]` based on the
 * link's token (EIP-3009 → x402, native/non-EIP-3009 → direct).
 * The webapp doesn't compute this — it trusts the backend so a
 * future addition to `EIP_3009_COMPATIBLE` lights up the Wallet
 * tab for that token automatically, no webapp rebuild.
 *
 * `Card` is always rendered as a disabled "Coming soon" tab
 * regardless of the link — the design calls out the tab as a
 * roadmap signal; P3.3 lights it up with Stripe.
 */
export function PaymentMethodTabs({
  link,
  active = "x402",
  onChange,
}) {
  const methods = link?.paymentMethods || [];
  const showWallet = methods.includes("x402");
  const showDirect = methods.includes("direct");

  const TABS = [];
  if (showWallet) {
    TABS.push({ id: "x402", label: "Wallet", icon: FaWallet, enabled: true });
  }
  if (showDirect) {
    TABS.push({
      id: "direct",
      label: "Direct",
      icon: FaExchangeAlt,
      enabled: true,
    });
  }
  TABS.push({
    id: "card",
    label: "Card",
    icon: FaCreditCard,
    enabled: false,
    badge: "Coming soon",
  });

  return (
    <div className="pay-tabs" role="tablist">
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        const className = [
          "pay-tab",
          isActive ? "pay-tab--active" : "",
          !tab.enabled ? "pay-tab--disabled" : "",
        ]
          .filter(Boolean)
          .join(" ");
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            className={className}
            role="tab"
            aria-selected={isActive}
            aria-disabled={!tab.enabled}
            disabled={!tab.enabled}
            onClick={() => tab.enabled && onChange && onChange(tab.id)}
          >
            <Icon size={14} />
            {tab.label}
            {tab.badge && <span className="pay-tab__badge">{tab.badge}</span>}
          </button>
        );
      })}
    </div>
  );
}
